import $ from "jquery"

Date.prototype.Format = function(fmt)
{ //author: meizz
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}

Date.prototype.Parse = function(str) {
  let group = str.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)
  this.setFullYear(group[1]);
  this.setMonth(parseInt(group[2])-1, group[3]);
  // this.setDate();
  this.setHours(0);
  this.setMinutes(0);
  this.setSeconds(0);
  this.setMilliseconds(0);
}

// let request_url = "http://23.95.107.58:10808";
// window.request_host = "http://127.0.0.1:10808";
window.request_host = "https://packapi.felixtech.cn";
window.jwtToken = window.localStorage.getItem("token");
export default {
    request_url() {
        return window.request_host;
    },
    async login(body) {
        return new Promise((resolve, reject) => {
            fetch(window.request_host+"/login/auth", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            }).then((response) => {
                return response.json()
            }).then((response) => {
                if (response.err == 0) {
                    window.jwtToken = response.data;
                    window.localStorage.setItem("token", response.data);
                }
                resolve(response);
            })
        })
    },
    async request(path, params, contentType) {
        if (window.request_host== null || window.request_host== "") {
            window.location.href = "/login"
        }

        if (contentType == "application/json") {
            params = JSON.stringify(params)
        }
        
        return new Promise((resolve, reject)=>{
            let vo = {
                url: window.request_host+ path,
                type: "POST",
                timeout: 600000,
                headers: {  },
                data: params,
                success: (data) => {
                    resolve(data);
                },
                error: (e, status, error) => {
                    console.log(e, status, error)
                    if (e.status == 401) {
                        window.location.href = "/login"
                        return;
                    }
                    reject(e.responseJSON)
                },
            }
            if (contentType != null) {
                vo.contentType = contentType;
            }

            if (window.jwtToken != null && window.jwtToken != "") {
                vo.headers.Authorization = `${window.jwtToken}`;
            }
            $.ajax(vo) 
            
        })
    },

    async getApps(name, page, limit) {
        return this.request("/apk/apps/list", { name, page, limit });
    },
    async getChannels() {
        return this.request("/apk/channels");
    },
    async getKeystores() {
        return this.request("/apk/keystores");
    },
    async createTask(form) {
        return this.request("/apk/tasks/create", form);
    },
    async getTasks(app_id, version, channel, is_release, status, page, limit) {
        return this.request("/apk/get_tasks", { app_id, version, channel, is_release, status, page, limit });
    }
}